import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { EventType, InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from './authConfig';
import { useCart } from './CartContext';

const Navbar = ({ isAdmin = false, fetchingUserInfo = false }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { itemCount } = useCart();
  const [activeAccount, setActiveAccount] = useState(
    () => instance.getActiveAccount() || accounts[0] || null
  );

  useEffect(() => {
    const callbackId = instance.addEventCallback((event) => {
      const authSuccessEvents = [
        EventType.LOGIN_SUCCESS,
        EventType.ACQUIRE_TOKEN_SUCCESS,
        EventType.SSO_SILENT_SUCCESS,
      ];
      if (authSuccessEvents.includes(event.eventType) && event.payload?.account) {
        instance.setActiveAccount(event.payload.account);
        setActiveAccount(event.payload.account);
      }
    });
    return () => instance.removeEventCallback(callbackId);
  }, [instance]);

  useEffect(() => {
    setActiveAccount(instance.getActiveAccount() || accounts[0] || null);
  }, [accounts, instance]);

  const closeMenu = () => setMenuOpen(false);

  const handleSignIn = () => instance.loginRedirect(loginRequest);
  const handleSignOut = () => instance.logoutRedirect({ account: activeAccount });
  const handleSwitchAccount = () => {
    instance.loginRedirect({ ...loginRequest, prompt: 'select_account' });
  };

  return (
    <nav className="Navbar">
      <Link to="/" className="Navbar-brand" onClick={closeMenu}>
        <img src="/images/logo.svg" alt="Nuvolem logo" className="Navbar-logo" />
        <span className="Navbar-company">Nuvolem</span>
      </Link>

      <button
        className="Navbar-hamburger"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`Navbar-links${menuOpen ? ' open' : ''}`}>
        <Link to="/products" onClick={closeMenu}>Products</Link>
        <Link to="/about" onClick={closeMenu}>About</Link>
        <Link to="/contact" onClick={closeMenu}>Contact</Link>
        <Link to="/cart" className="Navbar-cart" onClick={closeMenu} aria-label={`Cart, ${itemCount} item${itemCount === 1 ? '' : 's'}`}>
          <img className="Navbar-cart-icon" src="/images/cart.svg" alt="" width="22" height="22" />
          {itemCount > 0 ? <span className="Navbar-cart-badge">{itemCount}</span> : null}
        </Link>
        {inProgress !== InteractionStatus.None ? null : fetchingUserInfo
          ? <span className="loading-text">Getting user info...</span>
          : isAdmin && <Link to="/admin" className="Navbar-signed-in-links" onClick={closeMenu}>Admin</Link>
        }
        {isAuthenticated ? (
          <>
            <span className="Navbar-username">{activeAccount?.name}<button className="btn btn--ghost" onClick={handleSwitchAccount}>Switch</button></span>
            <button className="btn btn--ghost" onClick={handleSignOut}>Sign Out</button>
          </>
        ) : (
          <button className="btn btn--ghost" onClick={handleSignIn}>Sign In</button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
